<template>
  <v-flex
    xs12
    md6
    xl4
  >
    <v-card
      :href="href"
      :to="typeof to !== 'undefined' ? { name: to, params: { lang: $i18n.locale } } : undefined"
      hover
      outlined
      class="mx-auto overflow-hidden"
    >
      <v-img
        :aspect-ratio="2"
        :src="require(`../assets/img/${image}`)"
        width="100%"
      />
      <v-card-title class="long-title-wrap">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <p
          class="mb-2"
        >
          {{ text }}
        </p>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'Cards',
  props: {
    title: {
      type: String,
      required: true
    },
    text: {
      default: undefined,
      type: String,
      required: false
    },
    image: {
      default: undefined,
      type: String,
      required: false
    },
    url: {
      default: undefined,
      type: String,
      required: false
    },
    to: {
      default: undefined,
      type: String,
      required: false
    },
    bbox: {
      default: '',
      type: String,
      required: false
    },
    layers: {
      default: undefined,
      type: Array,
      required: false
    },
    qlayers: {
      default: undefined,
      type: Array,
      required: false
    }
  },
  computed: {
    href () {
      if (typeof this.layers !== 'undefined') {
        return this.url + '&mylayers=%20' + this.layers.join('%20') + '&myqlayers=%20' + this.qlayers.join('%20') + '&bbox=' + this.bbox
      } else {
        return this.url
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
